import React from "react";
import { Carousel } from "../components/Home/Carousel";
import { FashionCategory } from "../components/Home/FashionCategory";
import { Product } from "../components/Home/Product";
import { Advert } from "../components/Home/Advert";
import { BestSeller } from "../components/Home/BestSeller";
import { Socials } from "../components/Home/Socials";
import { getAllDocuments } from "../firebase/firebaseCrud";
import { useCart } from "../context/cart-context";

const Home = () => {
  const { isLoading, setIsLoading } = useCart();

  const [products, setProducts] = React.useState("");

  const getProducts = async () => {
    const prods = await getAllDocuments("product-list");
    setProducts(prods);
  };

  React.useEffect(() => {
    getProducts();
  }, []);

  React.useEffect(() => {
    if (products.length <= 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [products]);

  // console.log("products", products);
  return (
    <>
      <Carousel />
      <FashionCategory />
      <Product data={products} />
      <Advert />
      <BestSeller data={products} />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </>
  );
};

export default Home;
